module.exports = {
  messages: {
    CN: {
      back: "返回",
      NextStep: "下一步",
      saveDraftBtn: "保存草稿",
      saveDraftSuccess: "已保存至草稿箱",
      selectUrl: "请输入正确的LinkedIn URL",
      EnterLinkedInSearchURL: "请输入领英搜索URL",
      findUrl: "如何找到LinkedIn URL",
      loginAccount: "登录您的LinkedIn账号",
      // Enterkeywords: "在搜索框中输入关键词，点击enter或者see all results",
      SelectThePeople:
        "选择people筛选，同时在Filter中设置更多搜索条件，点击show results",
      copyURL: "复制导航栏中的URL地址，到此输入框中",
      AddLeads: "添加潜在客户",
      importMethod: "导入方法",
      LinkedInSearchURL: "LinkedIn 搜索网址",
      SalesNavigator: "Sales Navigator",
      LinkedInEvents: "LinkedIn 活动",
      LinkedInPosts: "LinkedIn 帖子",
      ImportfromCSV: "从CSV导入",
      LinkedInGroup: "LinkedIn 群组",
      EnterLinkedInsearchURL: "输入LinkedIn搜索网址",
      PleaseenterLinkedInBasicURLhere: "请在此处输入LinkedIn基本搜索网址。",
      HowtofindbasicsearchURL: "如何找到基本搜索网址？",
      EnterkeyWords: `输入关键词，选择"人员"，并使用筛选器缩小潜在客户范围。`,
      CopyTheLink: "复制链接并粘贴到这里。",
      EnterSales: "输入销售导航器网址",
      PleaseEnterSalesNavigator: "请在此处输入销售导航器搜索网址。",
      Howtofindasales: "如何找到销售导航器网址？",
      Openyourbrowser: "打开浏览器并访问：https://www.linkedin.com/sales/",
      Logintoyoursales: "登录您的销售导航器账户。",
      Enterkeywordsandpress: "输入关键词并搜索",
      Usefilterstofind: "使用筛选器查找潜在客户。复制网址并粘贴到这里。",
      Youneedtoupgrade: "您需要升级到付费版本才能使用此功能。",
      Upgradenow: "立即升级",
      EnterLinkedInEventURL: "输入LinkedIn活动网址",
      PleaseenteraLinkedInEventURLhere: "请在此处输入LinkedIn帖子网址。",
      HowtofindaLinkedIneventURL: "如何找到LinkedIn活动网址？ ",
      OpenLinkedInandfindtheeven: "打开LinkedIn并找到您想参加的活动。  ",
      Copythelinkandpasteithere: "复制链接并粘贴到这里。",
      EnterLinkedInPostURL: "输入LinkedIn帖子网址",
      PleaseenterLinkedInPostURLhere: "请在此处输入LinkedIn帖子网址。",
      Likes: "点赞（给帖子点赞的人）",
      Comments: "评论（给帖子评论的人）",
      Reposts: "转发（转发帖子的人）",
      Note: "注意：请至少选择一项。",
      Howimportthepostleads: "如何导入帖子潜在客户？",
      Findpostfromrecommendations: `从推荐、个人资料或群组中找到帖子，点击右上角三个点。点击"复制帖子链接"  `,
      Pastethelinkhere: "将链接粘贴到这里。",
      SelectUsers: "选择点赞、评论或转发帖子的用户（至少选择一种行为）。",
      DownloadexampleCSV: "下载示例CSV",
      DropCSVupload: "将CSV文件拖放到此处或浏览文件上传",
      MapLinkedInUR: "*映射LinkedIn URL字段来源：",
      FirstName: "姓",
      LastName: "名",
      MapFirstName: "*映射名字字段来源：",
      MapLastName: "*映射姓氏字段来源：",
      MapCompany: "映射公司名字段来源：",
      MapLocation: "映射位置字段来源：",
      Maptitle: "映射职位字段来源：",
      MapEmail: "映射邮箱字段来源：",
      MapPhone: "映射电话号码字段来源：",
      HowtoimporttheCSVfile: "如何导入CSV文件？",
      DropCSVfilehere: "将CSV文件拖放到此处或浏览文件上传。",
      Maptheimportedfile: "将导入的文件字段映射到系统要求。  ",
      Clicknextstep: "点击下一步。",
      LinkedInGroups: "LinkedIn群组",
      EnterLinkedInGroupURL: "输入LinkedIn群组网址",
      PleaseenterLinkedInGroupURLhere: "请在此处输入LinkedIn群组网址。  ",
      HowtofindLinkedInGroupURL: "如何找到LinkedIn群组网址？",
      OpenLinkedInandfindthegroup:
        "打开LinkedIn并找到您想抓取潜在客户的群组。  ",
      Copythelinkandpasteithere2: "复制链接并粘贴到这里。",
      required: "该项为必填项",
      Recruiter: "Recruiter / Lite",
      EnterRecruiterURL: "输入recruiter URL",
      RecruitersearchURLhere: "请输入一个recruiter的URL",
      RecruiterURL: "如何找到recruiter的URL",
      RecruiterOpen:
        "打开浏览器并访问地址https://www.linkedin.com/talent/home ",
      RecruiterKeyWords: "在搜索框中输入关键词并在搜索结果中点击关键词",
      Usefilters: "使用筛选功能筛选候选人，并复制URL并粘贴到这里",
      uploading: "文件正在上传",
      inputCSV: "请上传csv文件",
      ClickShowAll: "点击查看全部进入到成员列表",
      OpenLinkedIn:
        "打开LinkedIn，输入关键词，找到您想参加的活动并进入详情页  ",
      ClickAttend: "点击attend加入该活动",
      GotoAttendees: "点击attendees进入活动成员列表",
      Copypaste: "复制链接并粘贴到这里",
      keyworkds: "根据您的咨询报告中推荐的关键词：",
      recruiterValidUrl: `此字段需要经过验证的Recruiter URL。
点击‘下一步’将触发验证——请在验证成功后继续操作。
验证通过后，我们将自动登录您的LinkedIn账户。请勿尝试单独登录，否则将干扰活动执行。`,
      cancel: "取消",
      submit: "提交",
      VerificationMethod: "验证方式",
      LinkedInMobileApp: "LinkedIn移动应用",
      ApprovedApp: "我已在应用中批准",
      quickVerification: "让我们快速验证一下",
      Step2HintTitle: "第 2 步（共 5 步）：告诉 AI 从哪里获取您的理想候选人。",
      Step2HintDesc: "我们推荐使用 <strong>LinkedIn 搜索 URL</strong>（最精准）。",
      ProHintBtnShow: "我是专家，最小化提示",
      ProHintBtnHide: "已最小化 · 显示完整说明",
      UploadSheet: "上传表格",
      LeadsUnit: "个潜在客户",
      LinkedInUrlPlaceholder: "LinkedIn URL",
      None: "无",
      EnterCode: "输入验证码",
      PasteUrlTip: "只需粘贴您在 LinkedIn 上设置好的候选人搜索结果页 URL。不确定如何获取？按照下方 2 个步骤操作 👇",
    },
    US: {
      back: "Back",
      NextStep: "Next Step",
      saveDraftBtn: "Save as Draft",
      saveDraftSuccess: "Saved to Drafts",
      selectUrl: "Please enter a valid LinkedIn URL",
      EnterLinkedInSearchURL: "Enter LinkedIn Search URL",
      findUrl: "How to find the LinkedIn URL",
      loginAccount: "Log in to your LinkedIn account",
      SelectThePeople:
        'Select the "People" filter, set additional search criteria in the filters, and click "Show results"',
      copyURL:
        "Copy the URL address from the navigation bar into this input box",
      AddLeads: "Add Leads",
      importMethod: "import method",
      LinkedInSearchURL: "LinkedIn search URL",
      SalesNavigator: "Sales Navigator",
      LinkedInEvents: "LinkedIn Events",
      LinkedInPosts: "LinkedIn Posts",
      ImportfromCSV: "Import from CSV",
      LinkedInGroup: "LinkedIn Group",
      EnterLinkedInsearchURL: "Enter LinkedIn search URL",
      PleaseenterLinkedInBasicURLhere:
        "Please enter a LinkedIn Basic search URL here.",
      HowtofindbasicsearchURL: "How to find a basic search URL?",
      EnterkeyWords:
        "Enter keywords, select “People,” and filter to narrow down potential leads.",
      CopyTheLink: "Copy the link and paste it here.",
      EnterSales: "Enter Sales Navigator URL",
      PleaseEnterSalesNavigator:
        "Please enter a Sales Navigator search URL here.",
      Howtofindasales: "How to find a sales navigator URL?",
      Openyourbrowser:
        "Open your browser and visit: https://www.linkedin.com/sales/",
      Logintoyoursales: "Log in to your sales navigator account.",
      Enterkeywordsandpress: "Enter keywords and press ",
      Usefilterstofind:
        "Use filters to find leads.Copy the URL and paste it here.",
      Youneedtoupgrade:
        "You need to upgrade to the paid version to access this feature.",
      Upgradenow: "Upgrade now",
      EnterLinkedInEventURL: "Enter LinkedIn Event URL",
      PleaseenteraLinkedInEventURLhere:
        "Please enter a LinkedIn Event URL here.",
      HowtofindaLinkedIneventURL: "How to find a LinkedIn event URL?",
      OpenLinkedInandfindtheeven:
        "Open LinkedIn and find the event you want to attend. ",
      Copythelinkandpasteithere: "Copy the link and paste it here.",
      EnterLinkedInPostURL: "Enter LinkedIn Post URL",
      PleaseenterLinkedInPostURLhere: "Please enter a LinkedIn Post URL here.",
      Likes: "Likes（pepple that liked the post）",
      Comments: "Comments（pepple that commented the post）",
      Reposts: "Reposts（pepple that posted the post）",
      Note: "Note: Please select at least one.",
      Howimportthepostleads: "How to import the post leads?",
      Findpostfromrecommendations:
        "Find a post from recommendations, a personal profile, or a group, and click the ",
      Pastethelinkhere: "Paste the link here.",
      SelectUsers:
        "Select users who have liked, commented on, or repost post (at least one action).",
      DownloadexampleCSV: "Download example CSV",
      DropCSVupload: "Drop a CSV file here or browse a file to upload",
      MapLinkedInUR: "*Map LinkedIn URL field from: ",
      FirstName: "First Name",
      LastName: "Last Name",
      MapFirstName: "*Map First Name field from: ",
      MapLastName: "*Map Last Name field from: ",
      MapCompany: "Map Company name field from: ",
      MapLocation: "Map Location field from: ",
      Maptitle: "Map title  field from: ",
      MapEmail: "Map Email field from: ",
      MapPhone: "Map Phone number  field from: ",
      HowtoimporttheCSVfile: "How to import the CSV file ?",
      DropCSVfilehere: "Drop a CSV file here or browse a file to upload.",
      Maptheimportedfile:
        "Map the imported file fields to the system requirements.",
      Clicknextstep: "Click next step.",
      LinkedInGroups: "LinkedIn Groups",
      EnterLinkedInGroupURL: "Enter LinkedIn Group URL",
      PleaseenterLinkedInGroupURLhere:
        "Please enter a LinkedIn Group URL here.",
      HowtofindLinkedInGroupURL: "How to find a LinkedIn Group URL?",
      OpenLinkedInandfindthegroup:
        "Open LinkedIn and find the group where you want to scrape potential leads. ",
      Copythelinkandpasteithere2: "Copy the link and paste it here.",
      required: "The item is required",
      Recruiter: "Recruiter / Lite",
      EnterRecruiterURL: "Enter Recruiter URL",
      RecruitersearchURLhere: "Please enter a Recruiter search URL here.",
      RecruiterURL: "How to find a Recruiter URL?",
      RecruiterOpen:
        "Open your browser and visit: https://www.linkedin.com/talent/home ",
      RecruiterKeyWords:
        "Enter keywords in the search box and click on them in the search results",
      Usefilters:
        "Use filters to find candidates. Then copy the URL and paste it here.",
      uploading: "File is uploading...",
      inputCSV: "Please upload a csv file",
      ClickShowAll: "Click show all and enter the member list.",
      OpenLinkedIn:
        "Open LinkedIn, search keywords, and enter your target event page ",
      ClickAttend: `Click "Attend" to join `,
      GotoAttendees: `Go to "Attendees" for member list `,
      Copypaste: "Copy & paste the link here ",
      keyworkds: `Based on the search keywords recommended in your
                    consultation report：`,
      recruiterValidUrl: ` This field requires a validated recruiter URL. 
Clicking "Next Step" will trigger verification—proceed only after successful validation.
Once verified, we automatically log into your LinkedIn account. Do not attempt to log in separately, as it will disrupt campaign execution.`,
      cancel: "cancel",
      submit: "submit",
      VerificationMethod: "Verification Method",
      LinkedInMobileApp: "LinkedIn Mobile App",
      ApprovedApp: "I've Approved in App",
      quickVerification: "Let's do a quick verification",
      Step2HintTitle: "Step 2 of 5: Tell the AI where to source your ideal candidates.",
      Step2HintDesc: "We recommend a <strong>LinkedIn search URL</strong> (most precise).",
      ProHintBtnShow: "I'm a pro, minimize hints",
      ProHintBtnHide: "Minimized · show full notes",
      UploadSheet: "Upload sheet",
      LeadsUnit: "leads",
      LinkedInUrlPlaceholder: "LinkedIn URL",
      None: "None",
      EnterCode: "Enter code",
      PasteUrlTip: "Just paste the URL of the candidate search results page you set up on LinkedIn. Not sure how to get it? Follow the 2 steps below 👇",
    },
    AR: {
      back: "العودة",
      NextStep: "التالي",
      saveDraftBtn: "حفظ كمسودة",
      saveDraftSuccess: "تم حفظه في المسودات",
      selectUrl: "يرجى إدخال رابط LinkedIn صالح",
      EnterLinkedInSearchURL: "LinkedInأدخل رابط بحث ",
      findUrl: " كيفية العثور على رابط LinkedIn",
      loginAccount: " قم بتسجيل الدخول إلى حساب LinkedIn الخاص بك",
      SelectThePeople: `- اختر فلتر "الأشخاص"، وقم بتعيين المزيد من معايير البحث في الفلاتر، ثم انقر على "عرض النتائج"`,
      copyURL: ` انسخ عنوان URL من شريط التنقل إلى مربع الإدخال هذا`,
      AddLeads: "إضافةعملاءمحتملين ",
      importMethod: "طريقةالاستيراد ",
      LinkedInSearchURL: "رابطلينكدإنللبحث ",
      SalesNavigator: "SalesNavigator",
      LinkedInEvents: "فعالياتلينكدإن",
      LinkedInPosts: "منشوراتلينكدإن",
      ImportfromCSV: "الاستيرادمنCSV",
      LinkedInGroup: "مجموعاتلينكدإن",
      EnterLinkedInsearchURL: "أدخلرابطلينكدإنللبحث",
      PleaseenterLinkedInBasicURLhere: "الرجاءإدخالرابطلينكدإنالأساسيللبحثهنا.",
      HowtofindbasicsearchURL: "كيفيةالعثورعلىرابطالبحثالأساسي؟",
      EnterkeyWords: `أدخلكلماتمفتاحية،اختر"أشخاص"،واستخدمالفلاترلتصفيةالعملاءالمحتملين.  `,
      CopyTheLink: "انسخالرابطوالصقههنا.  ",
      EnterSales: "أدخلرابطSalesNavigator  ",
      PleaseEnterSalesNavigator: "الرجاءإدخالرابطللبحثفيSalesNavigatorهنا.  ",
      Howtofindasales: "كيفيةالعثورعلىرابطSalesNavigator؟ ",
      Openyourbrowser: "افتحالمتصفحواذهبإلى:https://www.linkedin.com/sales/  ",
      Logintoyoursales: "سجلالدخولإلىحسابSalesNavigatorالخاصبك.  ",
      Enterkeywordsandpress: "أدخلكلماتمفتاحيةواضغطعلىالبحث  ",
      Usefilterstofind:
        "استخدمالفلاترللعثورعلىعملاءمحتملين.انسخالرابطوالصقههنا.  ",
      Youneedtoupgrade: "تحتاجإلىالترقيةللإصدارالمدفوعللاستخدامهذهالميزة.",
      Upgradenow: "قمبالترقيةالآن",
      EnterLinkedInEventURL: "أدخلرابطفعاليةلينكدإن",
      PleaseenteraLinkedInEventURLhere: "الرجاءإدخالرابطفعاليةلينكدإنهنا. ",
      HowtofindaLinkedIneventURL: "كيفيةالعثورعلىرابطفعاليةلينكدإن؟",
      OpenLinkedInandfindtheeven: "افتحلينكدإنوابحثعنالفعاليةالتيتريدحضورها. ",
      Copythelinkandpasteithere: "انسخالرابطوالصقههنا.",
      EnterLinkedInPostURL: "أدخلرابطمنشورلينكدإن",
      PleaseenterLinkedInPostURLhere: "الرجاءإدخالرابطمنشورلينكدإنهنا.",
      Likes: "الإعجابات(الأشخاصالذينأعجبهمالمنشور) ",
      Comments: "التعليقات(الأشخاصالذينعلقواعلىالمنشور)",
      Reposts: "إعادةالنشر(الأشخاصالذينأعادوانشرالمنشور) ",
      Note: "ملاحظة:الرجاءاختيارخيارواحدفقط.",
      Howimportthepostleads: "كيفيةاستيرادالعملاءالمحتملينمنالمنشور؟",
      Findpostfromrecommendations: `ابحثعنمنشورمنالتوصياتأوالملفالشخصيأوالمجموعة،وانقرعلىالنقاطالثلاثفيالزاويةالعلويةاليمنى.انقرعلى"نسخرابطالمنشور"`,
      Pastethelinkhere: "الصقالرابطهنا.",
      SelectUsers:
        "اخترالمستخدمينالذينأعجبوابالمنشورأوعلقواعليهأوأعادوانشره(اختيارإجراءواحدفقط).",
      DownloadexampleCSV: "تحميلCSVنموذجي ",
      DropCSVupload: "اسحبملفCSVهناأواستعرضلرفعالملف",
      MapLinkedInUR: "*تعيينحقلرابطلينكدإنمن: ",
      FirstName: "الاسم الأول",
      LastName: "الاسم الأخير",
      MapFirstName: "*تعيينحقلالاسمالأولمن:",
      MapLastName: "*تعيينحقلالاسمالأخيرمن:",
      MapCompany: "تعيينحقلاسمالشركةمن:",
      MapLocation: "تعيينحقلالموقعمن:",
      Maptitle: "تعيينحقلالمسمىالوظيفيمن:",
      MapEmail: "تعيينحقلالبريديالإلكترونيمن:",
      MapPhone: "تعيينحقلرقمالهاتفمن:",
      HowtoimporttheCSVfile: "كيفيةاستيرادملفCSV؟",
      DropCSVfilehere: "اسحبملفCSVهناأواستعرضلرفعالملف. ",
      Maptheimportedfile: "قمبتعيينحقولالملفالمستوردحسبمتطلباتالنظام.  ",
      Clicknextstep: "انقرعلىالخطوةالتالية.",
      LinkedInGroups: "مجموعاتلينكدإن",
      EnterLinkedInGroupURL: "أدخلرابطمجموعةلينكدإن",
      PleaseenterLinkedInGroupURLhere: "الرجاءإدخالرابطمجموعةلينكدإنهنا.",
      HowtofindLinkedInGroupURL: "كيفيةالعثورعلىرابطمجموعةلينكدإن؟",
      OpenLinkedInandfindthegroup:
        "افتحلينكدإنوابحثعنالمجموعةالتيتريداستخراجالعملاءالمحتملينمنها.",
      Copythelinkandpasteithere2: "انسخالرابطوالصقههنا.",
      required: "هذا هو المطلوب",
      Recruiter: "نسخة خفيفة / لايت",
      EnterRecruiterURL: "أدخل رابط مسؤول التوظيف",
      RecruitersearchURLhere: "الرجاء إدخال رابط بحث مسؤول التوظيف هنا.",
      RecruiterURL: "كيفية العثور على رابط مسؤول التوظيف؟",
      RecruiterOpen:
        "١. افتح متصفحك وقم بزيارة: https://www.linkedin.com/talent/home",
      RecruiterKeyWords:
        "٢. أدخل الكلمات الرئيسية في مربع البحث وانقر عليها في نتائج البحث",
      Usefilters:
        "٣. استخدم الفلاتر للعثور على المرشحين. ثم انسخ الرابط والصقه هنا.",
      uploading: "جاري رفع الملف...",
      inputCSV: "يرجى رفع ملف بصيغة CSV",
      ClickShowAll: `انقر فوق "عرض الكل" وأدخل قائمة الأعضاء.`,
      OpenLinkedIn:
        "افتح لينكدإن، ابحث باستخدام الكلمات المفتاحية، وادخل إلى صفحة الحدث الذي تريده",
      ClickAttend: `اضغط على زر "Attend" للانضمام`,
      GotoAttendees: `انتقل إلى "Attendees" لعرض قائمة الأعضاء`,
      Copypaste: "انسخ الرابط والصقه هنا",
      keyworkds: `بناءً على كلمات البحث الموصى بها في تقرير الاستشارة الخاص بك`,
      recruiterValidUrl: `هذا الحقل يتطلب عنوان URL للمُوظِّف مُعتمَد.
سيؤدي النقر على ""الخطوة التالية"" إلى تفعيل عملية التحقق - المتابعة فقط بعد اكتمال التحقق بنجاح.
بعد الاعتماد، سنقوم تلقائيًا بتسجيل الدخول إلى حساب لينكدإن الخاص بك. لا تحاول تسجيل الدخول بشكل منفصل حتى لا يتعارض مع تنفيذ الحملة.`,
      cancel: "إلغاء",
      submit: "تقديم",
      VerificationMethod: "طريقة التحقق",
      LinkedInMobileApp: "تطبيق لينكدإن للجوال",
      ApprovedApp: "تمت الموافقة عبر التطبيق",
      quickVerification: "دعنا نقوم بالتحقق السريع",
      Step2HintTitle: "الخطوة 2 من 5: أخبر الذكاء الاصطناعي من أين يحصل على مرشحيك المثاليين.",
      Step2HintDesc: "نوصي باستخدام <strong>رابط بحث LinkedIn</strong> (الأكثر دقة).",
      ProHintBtnShow: "أنا محترف، إخفاء التلميحات",
      ProHintBtnHide: "تم الإخفاء · إظهار الملاحظات الكاملة",
      UploadSheet: "تحميل ورقة",
      LeadsUnit: "عميل محتمل",
      LinkedInUrlPlaceholder: "رابط LinkedIn",
      None: "لا شيء",
      EnterCode: "أدخل الرمز",
      PasteUrlTip: "فقط الصق رابط صفحة نتائج بحث المرشحين التي قمت بإعدادها على LinkedIn. لست متأكدًا من كيفية الحصول عليه؟ اتبع الخطوتين أدناه 👇",
    },
  },
};
